import { graphql } from '~publish/graphql'
import type { ResultOf } from '~publish/graphql'

export const PostCardNotes_Note = graphql(`
  fragment PostCardNotes_Note on Note {
    __typename
    id
    text
    type
    createdAt
    updatedAt
    author {
      __typename
      id
      email
      avatar
      isDeleted
      name
    }
    allowedActions
  }
`)

export type PostCardNotes_NoteData = ResultOf<typeof PostCardNotes_Note>
